import React from 'react';
import styled from 'styled-components';
import Image from '../molecules/Image';
import PropTypes from 'prop-types';
import Buttons from '../organisms/Buttons';

const QuestionHolder = styled.div`
  margin: -4rem auto 3rem auto;
  width: 85%;
  min-height: 7rem;
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.colours.white};
  padding: 1.5rem 2rem;
  position: relative;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
  h1 {
    align-self: center;
    font-weight: normal;
    font-family: inherit;
    text-align: center;
    margin: 0;
    ${props => props.theme.typeStyles( 0 )};
    line-height: 1.2;
  }
`;
function Question( { data } ) {

  const { avatarPrefix, redirect, id, values, question, avatarImage } = data;

  return (
    <main>
      <Image source={avatarImage}/>
      <QuestionHolder><h1>{question}</h1></QuestionHolder>
      <Buttons
        avatarPrefix={avatarPrefix}
        redirect={redirect}
        id={id}
        values={values}/>
    </main>
  )
}

Question.propTypes = {
  data: PropTypes.shape({
    avatarPrefix: PropTypes.string,
    avatarImage: PropTypes.string,
    question: PropTypes.object,
    redirect: PropTypes.string,
    id: PropTypes.string,
    values: PropTypes.array
  }),

};

export default Question;
